import { createSlice } from '@reduxjs/toolkit'

export interface gameIdeaState {
  promptId: string
  gameIdea: {
    game_title: string
    game_description: string
    asset_description: string
    art_style: string
    game_type: string
    player_movement: string
    game_keywords: string
  }
}

const initialState: gameIdeaState = {
  promptId: '',
  gameIdea: {
    game_title: '',
    game_description: '',
    asset_description: '',
    art_style: '',
    game_type: '',
    player_movement: '',
    game_keywords: '',
  },
}

export const gameIdeaSlice = createSlice({
  name: 'gameIdea',
  initialState,
  reducers: {
    updateGameIdeaState: (state, action) => {
      return { ...state, ...action.payload }
    },
    setGameIdea: (state, action) => {
      state.gameIdea = action.payload
    },
    clearGameIdea: (state) => {
      state.gameIdea = {
        game_title: '',
        game_description: '',
        asset_description: '',
        art_style: '',
        game_type: '',
        player_movement: '',
        game_keywords: '',
      }
    },
  },
})

export const { updateGameIdeaState, setGameIdea, clearGameIdea } =
  gameIdeaSlice.actions

export default gameIdeaSlice.reducer
